import {handleValidationChange} from '../CommonValidation';

export const validateAttendance = (data, setIsError) => {
    var isValid = true;

    if(data.employee_id === "" || data.employee_id === undefined) {
        handleValidationChange("employee_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("employee_id", false, setIsError);
    }

    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }

    if(data.datetime === "" || data.datetime === undefined) {
        handleValidationChange("datetime", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("datetime", false, setIsError);
    }

    return isValid
  
}

export const validateAttendanceUpload = (branch_id, setIsError) => {
    var isValid = true;

    if(branch_id === "" || branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }
    return isValid
  
}


// to check if sales items required filleds have data
export const validateTimeSheet = (items) => {
        const errors = {};
        // const finalItems = []
        items.map((item, itemIndex) => {
            if (item.actual_timein === '' || item.actual_timein === null || item.actual_timein === undefined) {
                errors[itemIndex] = {
                ...errors[itemIndex],
                actual_timein: 'Time in is required',
                };
            }
        });

        return errors;

}
